/**
 * Lee (sin verificar: eso lo hace la API) los datos del token de identidad del empleado. Sirve para
 * saludarlo y para explicarle, sin llamar a la API, si le falta el permiso. La API decide siempre.
 */
export const GRUPO_ADMIN = "portal-admin";
const DOMINIO_ADMIN = "@bvlchile.com";

export interface Empleado {
  readonly correo: string;
  readonly nombre: string;
  readonly grupos: readonly string[];
}

function decodificar(segmento: string): unknown {
  const base64 = segmento.replace(/-/g, "+").replace(/_/g, "/");
  const relleno = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
  const bytes = Uint8Array.from(atob(relleno), (c) => c.charCodeAt(0));
  return JSON.parse(new TextDecoder().decode(bytes));
}

export function empleadoDelToken(idToken: string): Empleado {
  try {
    const datos = decodificar(idToken.split(".")[1] ?? "") as Record<string, unknown>;
    const texto = (v: unknown) => (typeof v === "string" ? v : "");
    const grupos = Array.isArray(datos["cognito:groups"])
      ? datos["cognito:groups"].filter((g): g is string => typeof g === "string")
      : [];
    return { correo: texto(datos.email).toLowerCase(), nombre: texto(datos.name), grupos };
  } catch {
    return { correo: "", nombre: "", grupos: [] };
  }
}

/** Misma regla que la API: correo @bvlchile.com y grupo `portal-admin`. */
export function tienePermiso(e: Empleado): boolean {
  return e.correo.endsWith(DOMINIO_ADMIN) && e.grupos.includes(GRUPO_ADMIN);
}
